// src/services/settingsService.ts
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface SiteSettings {
  siteName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  currency: string;
  taxRate: number;
  shippingThreshold: number;
  metaTitle: string;
  metaDescription: string;
}

class SettingsService {
  private settingsDoc = doc(db, 'settings', 'site');

  async getSettings(): Promise<SiteSettings | null> {
    try {
      const docSnap = await getDoc(this.settingsDoc);
      if (docSnap.exists()) {
        return docSnap.data() as SiteSettings;
      }
      return null;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  }

  async updateSettings(settings: Partial<SiteSettings>): Promise<void> {
    try {
      const docSnap = await getDoc(this.settingsDoc);
      if (docSnap.exists()) {
        await updateDoc(this.settingsDoc, settings);
      } else {
        await setDoc(this.settingsDoc, settings);
      }
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }
}

export const settingsService = new SettingsService();